import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { ExportButton, ExportButtonProps } from '../../../../Buttons/ExportButton';
import { Chip } from '../../../../Chip';
import { Typography } from '../../../../Typography';
import CreateButton, { CreateButtonProps } from '../../CreateButton';
export interface MainPageHeaderProps {
  isSmallDevice: boolean;
  title: string;
  subtitle: string;
  count?: string;
  exportButton?: Omit<ExportButtonProps, 'isSmallDevice'>;
  createButton?: Omit<CreateButtonProps, 'isSmallDevice'>;
  tabs?: () => React.ReactNode;
}
/**
 * The header component used for main pages.
 * It contains the title, subtitle, optional call to actions buttons (export button, create button), and optional tabs.
 * Used on Task list, Asset list, User list, Team list, Org list, Insights, Admin config & People pages.
 */
export const MainPageHeader = ({
  title,
  subtitle,
  count,
  exportButton,
  createButton,
  tabs,
  isSmallDevice,
}: MainPageHeaderProps) => {
  return (
    <>
      <Stack
        direction={isSmallDevice ? 'column' : 'row'}
        gap={isSmallDevice ? '16px' : undefined}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Stack direction="column" gap={'4px'}>
          {title && (
            <Stack direction="row" gap={'10px'} alignItems="center">
              <Typography
                variant="h1"
                component="h1"
                data-testid="title"
                sx={{ fontSize: '24px', fontWeight: 700, lineHeight: '32px', color: '#181D27' }}
              >
                {title}
              </Typography>
              {count && <Chip label={count} variant="outlined" size="small" />}
            </Stack>
          )}
          {subtitle && (
            <Typography
              variant="body1"
              component="h2"
              color="textSecondary"
              sx={{ fontSize: '16px', fontWeight: 400, lineHeight: '24px', color: '#535862' }}
            >
              {subtitle}
            </Typography>
          )}
        </Stack>
        {(exportButton || createButton) && (
          <Stack direction="row" gap={'12px'} flexWrap="wrap" justifyContent="flex-end">
            {exportButton && <ExportButton {...exportButton} isSmallDevice={false} />}
            {createButton && <CreateButton {...createButton} isSmallDevice={false} />}
          </Stack>
        )}
      </Stack>
      <Box sx={{ mt: '16px' }}>{tabs ? tabs() : <Divider />}</Box>
    </>
  );
};
